export default function useAdminSMS(props) {
  return {};
}
